import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-766e2c90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "back-link" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-fanhui" }, null, -1))
const _hoisted_3 = { class: "title" }

import { t } from '@/plugins/i18n'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const back = () => {
  history.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "back",
      onClick: back
    }, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_unref(t)('返回')), 1)
    ]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(route).meta.title), 1)
  ]))
}
}

})